export class SurveyFSEDto {
  constructor(
    public id: number,
    public version: number,
    public communityActionId: number,
    public assessmentSourceId: number,
    public surveyContextId: number,
    public structureId: number,
    public year: string,
    public beginDate: Date,
    public endDate: Date,
    public exitQuestion1: boolean | undefined,
    public exitQuestion2: string | undefined,
    public exitQuestion3: string | undefined,
    public exitQuestion4: string,
    public exitQuestion5: string,
    public exitQuestion6: string,
    public exitQuestion7: string,
    public exitQuestion8: string,
    public entryQuestion1: string,
    public entryQuestion1e: string | undefined,
    public entryQuestion1f: string | undefined,
    public searchingSince: Date | undefined,
    public entryQuestion2: string,
    public entryQuestion3: string,
    public entryQuestion4: string,
    public entryQuestion4a: string,
    public entryQuestion4b: string,
    public entryQuestion4c: string,
    public entryQuestion4d: string,
    public entryQuestion4e: string,
    public entryQuestion4f: string,
    public entryQuestion4g: string,
    public entryQuestion4h: string,
    public entryQuestion5: string,
    public entryQuestion6: string,
    public entryQuestion7: string,
    public entryQuestion8: string,
    public entryQuestion9: string,
    public entryQuestion9a: Date,
  ) {}

  public static fromJson(json: any): SurveyFSEDto {
    if (json) {
      return new SurveyFSEDto(
        json.id,
        json.version,
        json.communityActionId,
        json.assessmentSource?.id,
        json.surveyContextId,
        json.structureId,
        json.year,
        json.beginDate ? new Date(json.beginDate) : undefined,
        json.endDate ? new Date(json.endDate) : undefined,
        json.exitQuestion1,
        json.exitQuestion2,
        json.exitQuestion3,
        json.exitQuestion4,
        json.exitQuestion5,
        json.exitQuestion6,
        json.exitQuestion7,
        json.exitQuestion8,
        json.entryQuestion1,
        json.entryQuestion1e,
        json.entryQuestion1f,
        json.searchingSince ? new Date(json.searchingSince) : undefined,
        json.entryQuestion2,
        json.entryQuestion3,
        json.entryQuestion4,
        json.entryQuestion4a,
        json.entryQuestion4b,
        json.entryQuestion4c,
        json.entryQuestion4d,
        json.entryQuestion4e,
        json.entryQuestion4f,
        json.entryQuestion4g,
        json.entryQuestion4h,
        json.entryQuestion5,
        json.entryQuestion6,
        json.entryQuestion7,
        json.entryQuestion8,
        json.entryQuestion9,
        json.entryQuestion9a ? new Date(json.entryQuestion9a) : undefined,
      );
    }
  }
}
